import { useEffect } from 'react';
import { useMatch, useNavigate, Outlet } from 'react-router-dom';
import { Tabs, PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetAmlDictionariesQuery,
  useLazyGetAmlBaseCurrenciesQuery,
  useLazyGetAmlCurrenciesQuery,
  useGetAmlTransactionTypesQuery,
} from '../../store/dictionaries/services';

import ROUTES from '../../routes';

import cn from './transactions-risk.module.css';

const TransactionsRisk = () => {
  const match = useMatch(ROUTES.TRANSACTIONS_RISK);

  const navigate = useNavigate();

  const { activePermissions, currencies, riskScoreRanges, baseCurrency } =
    useAppSelector((state) => state.amlDictionaries);

  const [getDictionaries] = useLazyGetAmlDictionariesQuery();
  const [getAmlBaseCurrency] = useLazyGetAmlBaseCurrenciesQuery();
  const [getAmlCurrencies] = useLazyGetAmlCurrenciesQuery();

  useGetAmlTransactionTypesQuery();

  useEffect(() => {
    if (
      match &&
      activePermissions?.includes(
        PermissionEnum.SETTINGS_TRANSACTIONS_VOLUMES_LIST,
      )
    ) {
      navigate(ROUTES.TRANSACTIONS_RISK_GEOGRAPHICAL);
    }
  }, [match, activePermissions]);

  useEffect(() => {
    if (
      activePermissions?.includes(
        PermissionEnum.SETTINGS_TRANSACTIONS_VOLUMES_LIST,
      )
    ) {
      if (!riskScoreRanges) {
        getDictionaries();
      }

      if (!baseCurrency) {
        getAmlBaseCurrency();
      }

      if (!currencies) {
        getAmlCurrencies();
      }
    }
  }, [activePermissions, currencies, riskScoreRanges, baseCurrency]);

  useEffect(() => {
    let title = 'Transactions risk';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.transactionsRiskLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(
        PermissionEnum.SETTINGS_TRANSACTIONS_VOLUMES_LIST,
      ) ||
      !activePermissions.includes(PermissionEnum.SECTION_AML_KYC)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.transactionsRisk}>
          <div className={cn.transactionsRiskTitle}>Transactions risk</div>
          <div className={cn.transactionsRiskTabsWrapper}>
            <Tabs
              itemClassName={cn.transactionsRiskTabItem}
              tabs={[
                {
                  name: 'Geographical risk',
                  path: ROUTES.TRANSACTIONS_RISK_GEOGRAPHICAL,
                },
                {
                  name: 'Volumes risk scores',
                  path: ROUTES.TRANSACTIONS_RISK_VOLUME_RISK,
                },
                {
                  name: 'Calculation rules',
                  path: ROUTES.TRANSACTIONS_RISK_CALCULATION,
                },
                {
                  name: 'Transaction types scores',
                  path: ROUTES.TRANSACTIONS_RISK_TYPES_RISK,
                  hidden: !activePermissions.includes(
                    PermissionEnum.SETTINGS_TRANSACTIONS_TYPES_RISK_SCORE_LIST,
                  ),
                },
              ]}
              enableRouting
            />
          </div>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default TransactionsRisk;
